import { css } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
  top: css(mq({
    height: [44, null, 80],
    background: '#2E0303',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.3s',
  })),
  topScrolled: css(mq({
    height: [44, null, 80],
    // background: '#BA4242',
  })),
  logo: css(mq({
    display: 'flex',
    justifyContent: 'center',
    transition: 'all 0.3s ease-in-out',
    marginLeft: ['0.5rem', null, '6rem'],
    zIndex: 2,
    flexShrink: 0,
    width: [50, null, 200],
    height: [44, null, 80],
    position: 'relative',
    overflow: 'visible',
    alignSelf: 'flex-start',
    '@media (max-width: 1199px)': {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      marginLeft: 0,
    },
  })),
  logoImg: css(mq({
    display: 'block',
    height: [80, null, 200],
    width: 'auto',
    maxHeight: 'none',
    transition: 'all 0.3s ease-in-out',
    position: 'absolute',
    top: '.4rem',
    left: '50%',
    transform: 'translateX(-50%)',
  })),
  logoImgScrolled: css(mq({
    height: [30, null, 68],
  })),
  logoScrolled: css(mq({
  })),
  topHeaderRight: css(mq({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: ['0.5rem', null, '3rem'],
    zIndex: 2,
    flexShrink: 0,
  })),
  navBarHori: css(mq({
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '60%',
    zIndex: 1,
  })),
  paypalBtn: css(mq({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: '6rem',
    zIndex: 2,
    transition: 'opacity 0.3s',
    '& img': {
      height: 32,
      width: 'auto',
    },
    '&:hover': {
      opacity: 0.8,
    },
    '@media (max-width: 1199px)': {
      display: 'none',
    },
  })),
  top__navi__con__wrap: mq({
    background: "#002e5b",
    // padding: "5px 5px 2px",
    position: "relative",
    height: ["39px", null, "auto"],
  }),

  top__navi__item: mq({
    color: "white",
    fontSize: "0.8rem",
    position: "relative",
    svg: {
      paddingBottom: "3px",
      marginRight: "10px",
    },
    a: {
      color: "inherit",
      display: "inline-block",
      padding: "0.4rem 0.5rem 11px",
      fontWeight: 600,
      fontSize: "0.65rem",
      "&:hover": {
        textDecoration: "none",
        backgroundColor: "yellow",
      },
    },
  }),

  mast__head__svg__warpp: mq({
    position: "relative",
    // "&:before": mq({
    //   content: "''",
    //   width: "50%",
    //   left: 0,
    //   top: 0,
    //   height: "74px",
    //   position: "absolute",
    //   backgroundColor: "white",
    //   display: ["none", null, "block"],
    //   zIndex: "-1",
    //   transition: "all 0.5s ease",
    //   transform: "rotate(1deg)",
    //   "@media (min-width: 2561px)": {
    //     //display: 'block',
    //     transform: "rotate(0deg)",
    //   },
    // }),
    "&:after": mq({
      content: "''",
      width: "50%",
      right: 0,
      top: 0,
      height: "75%",
      position: "absolute",
      backgroundColor: "white",
      display: ["none", null, "block"],
      zIndex: "-1",
      transition: "all 0.5s ease",
      transform: "rotate(-1deg)",
      "@media (min-width: 2561px)": {
        //display: 'block',
        transform: "rotate(0deg)",
      },
    }),
  })
}